import { Injectable } from '@angular/core';
import {BaseApiService} from '../../common/base-api.service';
import {HttpClient} from '@angular/common/http';
import {SettingsProviderService} from '../../common/settings-provider.service';
import {Observable} from 'rxjs';
import {ICompanyInfo} from '../../message-models/company-info.interface';
import {ICompanyOptInAcceptanceSummary} from '../../message-models/company-opt-in-acceptance-summary.interface';
import {OptInAction} from '../../message-models/optin-action.interface';
import {IOptInModalInfo} from '../../message-models/optin-modal-info.interface';

@Injectable({
  providedIn: 'root'
})
export class CompanyOptInService extends BaseApiService {

  constructor(http: HttpClient) {
    super(http, new SettingsProviderService('ecaApi'), 'CompanyOptIn');
  }

  getPendingCompanyOptInAcceptances(companyId: string): Observable<ICompanyOptInAcceptanceSummary[]> {
    return this.post<ICompanyOptInAcceptanceSummary[]>('GetPendingCompanyOptInAcceptances', { companyId });
  }

  recordOptInAction(action: OptInAction): Observable<ICompanyOptInAcceptanceSummary> {
    return this.post<ICompanyOptInAcceptanceSummary>('RecordOptInAction', {companyId: action.companyId, optInEntryId: action.optInEntryId, visited: action.visited, decision: action.decision})
  }

  recordContractAgreed(companyId: string): Observable<ICompanyInfo> {
    return this.post<ICompanyInfo>('recordContractAgreed', {companyId: companyId})
  }

  recordOptInActions(actions: OptInAction[]): Observable<boolean> {
    return this.post<boolean>('RecordOptInActions', {optInActions:actions})
  }

  getOptInModalDetails():Observable<IOptInModalInfo> {
    return this.post<IOptInModalInfo>('GetOptInModalDetails');
  }
}
